
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/identity/partnerships/alloy",
      function () {
        return require("private-next-pages/docs/identity/partnerships/alloy.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/identity/partnerships/alloy"])
      });
    }
  